<template>
  <header class="header">
    <div class="container">
      <div class="logo">
        <img src="../assets/logo.png" alt="康道道" />
      </div>
      <nav class="nav">
        <ul class="nav-list">
          <li class="nav-item">
            <router-link to="/" :class="{ active: $route.name === 'Home' }">首页</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/platform-value" :class="{ active: $route.name === 'PlatformValue' }">平台价值</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/product-system" :class="{ active: $route.name === 'ProductSystem' }">产品体系</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/solution" :class="{ active: $route.name === 'Solution' }">解决方案</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/data-visualization" :class="{ active: $route.name === 'DataVisualization' }">数据可视化</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/cooperation-cases" :class="{ active: $route.name === 'CooperationCases' }">合作案例</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/about-us" :class="{ active: $route.name === 'AboutUs' }">关于我们</router-link>
          </li>
        </ul>
      </nav>
      <div class="header-btn">
        <a href="https://kdd.binjiela.com.cn" target="_blank" class="btn-login">登录管理后台</a>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 80px;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.header .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.logo {
  height: 80px;
  line-height: 80px;
}

.logo img {
  height: 50px;
  vertical-align: middle;
  margin-top: -10px;
}

.nav {
  flex: 1;
  text-align: center;
}

.nav-list {
  display: inline-block;
  list-style: none;
  margin: 0;
  padding: 0;
  text-align: left;
}

.nav-item {
  display: inline-block;
  margin-right: 25px;
  white-space: nowrap;
}

.nav-item a {
  display: block;
  line-height: 27px;
  color: #333;
  text-decoration: none;
  font-size: 18px;
  transition: color 0.3s;
  padding: 0 10px;
}

.nav-item a:hover,
.nav-item a.active {
  color: #1ca196;
  background: #1ca19633;
  border-radius: 6px;
}

.header-btn {
  margin-left: 20px;
}

.btn-login {
  display: inline-block;
  padding: 8px 20px;
  background-color: #1ca196;
  color: #fff;
  text-decoration: none;
  border-radius: 4px;
  font-size: 14px;
  transition: background-color 0.3s;
}

.btn-login:hover {
  background-color: #1a9a8b;
}
</style>
